<template>
  <div>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="9">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="reset"
                @keydown="form.onKeydown($event)"
            >
                <v-container grid-list-xl>
                    <v-toolbar dark>
                        <v-toolbar-title> {{ title }} </v-toolbar-title>
                        <v-spacer />
                    </v-toolbar>
                    <v-layout class="wrap justify-space-around form-body">
                        <v-col cols="12">
                            <v-text-field
                                v-model.trim="form.name"
                                :rules="[rules.required]"
                                :maxlength="50"
                                label="Nombre"
                                placeholder="inicio"
                                required
                            />
                            <v-text-field
                                v-model.trim="form.description"
                                :rules="[rules.required]"
                                :maxlength="100"
                                label="Descripción"
                                placeholder="Acesso a menú inicio"
                                required
                            />
                        </v-col>
                        <div class="mb-3">
                            <v-btn class="mr-5" color="success" @click="save">
                                Guardar
                            </v-btn>
                            <v-btn color="red" @click="cancel">
                                Cancelar
                            </v-btn>
                        </div>
                    </v-layout>
                </v-container>
            </v-form>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import Form from 'vform';

export default {
    metaInfo() {
        return { title: this.$t('home') };
    },
    props: {
      permissionId: { default: '' },
    },
    data: () => ({
      form: new Form({
        name: '',
        description: '',
        busy: false,
        active: false,
      }),
      items: [],
      next: 1,
      title: 'Nuevo permiso del sistema',
      rules: {
        required: (v) => !!v || 'El campo es requerido',
      },
      method: 'POST',
      apiURL: '/api/maintenance/permissions/store',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      if (this.permissionId) {
        window.axios.get(`/api/maintenance/permissions/${this.permissionId}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.disabled = true;
          this.apiURL = `/api/maintenance/permissions/${this.permissionId}/update`;
          this.method = 'PUT';
          this.title = 'Editar permiso del sistema';
          this.message = `Se ha editado el permiso ${result.data.name} exitosamente.`;
        });
      }
    },
    methods: {
        cancel() {
            this.$router.go(-1); // someValue
        },
        save() {
            this.validate();
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.form.busy = true;
                this.store();
            }
        },
        store() {
            window.axios({
                method: this.method,
                url: this.apiURL,
                data: this.form,
            }).then((result) => {
                this.$router.push({ name: 'maintenance.permissions', params: { action: 'created', message: result.data.message } });
            }).catch(() => {
                this.form.busy = false;
            });
        },
    },
};
</script>

<style>

</style>
